var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static--menu--item",class:{
    selected: _vm.isSelected
},on:{"click":_vm.usage}},[_c('div',{staticClass:"icon_cont"},[_c('span',{staticClass:"iconify",attrs:{"data-width":"30","data-height":"30","data-icon":_vm.icon}})])])}
var staticRenderFns = []

export { render, staticRenderFns }